import { render, staticRenderFns } from "./OptionChart.vue?vue&type=template&id=62984d13&lang=pug"
import script from "./OptionChart.vue?vue&type=script&lang=js"
export * from "./OptionChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports